/* BSC Academy — aggiunta rapida al carrello · v1 · 26/08/2026

   Le schede percorso hanno un pulsante a icona che aggiunge al carrello.
   Senza questo file il form fa il suo POST normale e si finisce su /cart:
   funziona, ma butta fuori dal catalogo chi stava guardando. Qui l'aggiunta
   avviene sul posto e la pagina non si muove.

   ⚠️ Il pulsante «Acquista» della pagina percorso NON viene intercettato.
   Li l'intenzione e diversa — si e gia scelto — e «Acquista» deve fare
   quello che dice: portare al carrello. → MANUALE-COPY-BSC.md §6

   Nessuna stringa scritta qui dentro: il riscontro e l'icona che diventa
   una spunta, e il numero nell'header che sale. → CLAUDE.md regola 11 */
(function () {
  'use strict';

  var conta = document.querySelector('[data-bsc-conta]');
  var link = document.querySelector('[data-bsc-cart]');

  function aggiornaConteggio(n) {
    if (conta) {
      conta.textContent = n;
      conta.hidden = n === 0;
    }
    /* l'etichetta per chi non vede porta gia il numero: si riscrive solo
       la coda, cosi la parola resta quella scelta nelle impostazioni */
    if (link) {
      var et = link.getAttribute('aria-label') || '';
      link.setAttribute('aria-label', et.replace(/,\s*\d+\s*$/, '') + ', ' + n);
    }
  }

  function riscontro(bottone) {
    bottone.classList.add('bsc-perc__bt--fatto');
    setTimeout(function () { bottone.classList.remove('bsc-perc__bt--fatto'); }, 1400);
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest('.bsc-perc__form');
    if (!form) { return; }
    ev.preventDefault();

    var bottone = form.querySelector('button[type=submit]');
    if (bottone && bottone.disabled) { return; }
    if (bottone) { bottone.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) { if (!r.ok) { throw new Error(r.status); } return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (carrello) {
        aggiornaConteggio(carrello.item_count);
        if (bottone) { riscontro(bottone); }
      })
      .catch(function () {
        /* se la rete cade il form fa quello che avrebbe fatto senza di noi */
        form.submit();
      })
      .then(function () { if (bottone) { bottone.disabled = false; } });
  });
})();
